import { useState } from "react";

interface UseStatisticsModalReturn {
  isOpen: boolean;
  openStatistics: () => void;
  closeStatistics: () => void;
}

export const useStatisticsModal = (): UseStatisticsModalReturn => {
  const [isOpen, setIsOpen] = useState(false);

  const openStatistics = () => setIsOpen(true);
  const closeStatistics = () => setIsOpen(false);

  return {
    isOpen,
    openStatistics,
    closeStatistics,
  };
};
